import Moderator from '@/models/bread/Moderator/shopItem'

export default {
  key:'ShopItem',
  name:{
    singular:'ShopItem',
    plural:'ShopItems',
  },
  parents:[
    //
  ],
  Admin:false,
  Moderator:Moderator,
  Teacher:false,
}